import { generateArcVertices, getEntityExtrusionTransform } from "./helpers";
export function decomposeEllipse(entity, dxfHeaders) {
    const xR = Math.sqrt(entity.majorAxisEndPoint.x * entity.majorAxisEndPoint.x +
        entity.majorAxisEndPoint.y * entity.majorAxisEndPoint.y);
    const yR = xR * entity.axisRatio;
    const rotation = Math.atan2(entity.majorAxisEndPoint.y, entity.majorAxisEndPoint.x);
    const vertices = generateArcVertices({
        center: entity.center,
        radius: xR,
        startAngle: entity.startAngle,
        endAngle: entity.endAngle,
        yRadius: yR,
        transform: getEntityExtrusionTransform(entity),
        dxfHeaders,
    });
    if (rotation !== 0) {
        //XXX should account angDir?
        const cos = Math.cos(rotation);
        const sin = Math.sin(rotation);
        for (const v of vertices) {
            const tx = v.x - entity.center.x;
            const ty = v.y - entity.center.y;
            /* Rotate the vertex around the ellipse center point. */
            v.x = tx * cos - ty * sin + entity.center.x;
            v.y = tx * sin + ty * cos + entity.center.y;
        }
    }
    return vertices;
}
//# sourceMappingURL=decomposeEllipse.js.map